/**
 * /profile — kept as a thin redirector to the unified Beit Midrash workspace.
 * Per the central-state architecture, there is now ONLY ONE personal area
 * ("בית המדרש שלי"). External links pointing to /profile still land users
 * in the right place.
 */
import { Navigate } from "react-router-dom";

export default function Profile() {
  return <Navigate to="/beit-midrash" replace />;
}
